import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from "react-router-dom";
import {
  Card,
  Form,
} from "tabler-react";

import {
  LoadingButton,
  AlertComponent
} from '../../../component';
import {
  userActions,
  alertActions
} from '../../../store/actions';

import { history } from '../../../utils/helpers/history';


class LoginPage extends Component {

  constructor(props) {
    super(props);

    history.listen((location, action) => {
      // clear alert on location change
        this.props.clearAlerts();
    });
    this.state = {
        email: '',    // Form fields
        password: '', // Form fields
        error: '',    // Initialized to handle validation errors
        history:''    // Initialized to  save browser history and redirection
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      history: this.props.history
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let validationCheck = this.handleValidation();

    if(validationCheck.email === '' && validationCheck.password === '')
    {
      this.props.login(this.state);
    }
  }

  handleValidation = (e) => {
    let values = this.state;
    // same as above, but feel free to move this into a class method now.
    let errors = {
      email: '',
      password: '',
    };
    if (!values.email) {
      errors.email = "This field is required";
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email))
    {
      errors.email = "Invalid email address";
    }
    if (!values.password)
    {
      errors.password = "This field is required";
    }
    this.setState({
      error: errors
    })
    return errors;
  }

  render() {
    let alertComponent="";
    const { alert, loggedIn } = this.props;
    const errors = this.state.error;
    if (alert !== {}) {
      alertComponent =  (alert.message&&alert.type) && <AlertComponent alert={alert} auth={true}/>;
    }
    return (
      <Form className="card" onSubmit={this.handleSubmit}>
        <Card.Body className="p-4">
          <div className="text-center mb-6 p-4">
            <img src="./demo/logo.png" className="h-6 " alt="logo"/>
          </div>
          <Card.Title className="text-center">Login to your Account</Card.Title>
          {alertComponent&&alertComponent}
              <Form.Group>
                <Form.Label>Email Address</Form.Label>
                <Form.Input
                  type="email"
                  name="email"
                  placeholder= 'Enter Email Address'
                  error= {errors && errors.email}
                  onChange={this.handleChange}
                  value={this.state.email}
                />
            </Form.Group>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Input
                type="password"
                name="password"
                placeholder= 'Enter Password'
                error= {errors && errors.password}
                onChange={this.handleChange}
                value={this.state.password}
              />
            </Form.Group>
          <div className="text-left p-2">
            <NavLink to="/forgot">Forgot Password ?</NavLink>
          </div>
        </Card.Body>
        <Card.Footer className="text-right">
          <LoadingButton loadingState={loggedIn} preloadingText="Login" loadingText="Logging In"/> 
        </Card.Footer>
      </Form>

    );
  }

}
function mapStateToProps(state) {
  const { alert } = state;
  const { loggedIn } = state.authentication;
  return {
    alert,
    loggedIn
  };
}

const mapDispatchToProps = {
  login: userActions.login,
  errorAlerts: alertActions.error,
  successAlerts: alertActions.success,
  clearAlerts: alertActions.clear
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginPage));